// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "http://192.168.2.108:3000/api",
  headers: {
    "Content-Type": "application/json",
  },
});


axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => Promise.reject(err) 
);

export default axiosInstance;
